import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

import { localeCurrency } from "core/includes/formatters";
import ContentCombine from "core/Components/ContentCombine";
import useCart from "pages/Components/CartPage/hooks/useCart";

type Props = {
    title: string,
    price: number,
    isTotal?: boolean,
    isNegating?: boolean,
};

const TitleAndPrice: React.FC<Props> = ({ title, price, isTotal = false, isNegating = false }) => {
    const theme: Theme = useTheme();

    const { getCountry } = useCart();
    const countryCode = getCountry();

    const style = css`
        align-items: end;
        width: 100%;
    `;

    const titlesDivStyle = css`
        display: flex;
        justify-content: space-between;

        ${isTotal && css`
            font-weight: ${theme.fonts.weights.bold};
        `}
    `;

    return (
        <div css={style}>
            <div css={titlesDivStyle}>
                <ContentCombine fontSizeType={'18'}>{title}</ContentCombine>
                <ContentCombine fontSizeType={'18'}>
                    {isNegating ? "-" : ""}{localeCurrency(price, countryCode.currency)}
                </ContentCombine>
            </div>
        </div>
    );
};

export default TitleAndPrice;